import { inject, Injectable, Provider } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpErrorResponse,
} from "@angular/common/http";

import { Observable } from "rxjs";
import { AuthService } from "./auth-service.service";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";

/**
 * Functional HTTP interceptor that attaches the Auth0 Bearer token appropriate
 * for the request URL to outgoing API calls. On a 401 it redirects to login
 * only when the user is genuinely unauthenticated — a 401 on a valid session
 * indicates a token-audience misconfiguration, and redirecting would loop.
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const newReq = req.clone({
    headers: req.headers.set(
      "Authorization",
      "Bearer " + auth.getTokenForUrl(req.url),
    ),
  });

  return next(newReq).pipe(tap(() => {}, (err: any) => {
    if (err instanceof HttpErrorResponse) {
      if (err.status !== 401) {
        return;
      }
      // Only redirect to login if the user is genuinely unauthenticated.
      // A 401 while already logged in means a wrong token audience (config
      // issue), not an expired session — redirecting here causes the loop.
      if (auth.isLoggedIn) {
        console.warn('401 while authenticated — check Auth0 audience for:', req.url);
        return;
      }
      // Don't redirect while on /login — Auth0 callback is still processing.
      if (window.location.pathname.startsWith('/login')) {
        return;
      }
      auth.login(window.location.pathname);
    }
  }));
};